/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerGetTokenQueryResponse,
  TelegramChatsUserControllerGetToken401,
} from '../../types/TelegramChatsUserControllerGetToken.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramChatsUserGetToken } from '../../methods/telegramChatsUserGetToken.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramChatsUserGetTokenQueryKey = () => [{ url: '/api/user/telegram/chats/token' }] as const;

export type TelegramChatsUserGetTokenQueryKey = ReturnType<typeof telegramChatsUserGetTokenQueryKey>;

export function telegramChatsUserGetTokenQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramChatsUserGetTokenQueryKey();
  return queryOptions<
    TelegramChatsUserControllerGetTokenQueryResponse,
    ResponseErrorConfig<TelegramChatsUserControllerGetToken401>,
    TelegramChatsUserControllerGetTokenQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramChatsUserGetToken(config);
    },
  });
}

/**
 * {@link /api/user/telegram/chats/token}
 */
export function useTelegramChatsUserGetToken<
  TData = TelegramChatsUserControllerGetTokenQueryResponse,
  TQueryData = TelegramChatsUserControllerGetTokenQueryResponse,
  TQueryKey extends QueryKey = TelegramChatsUserGetTokenQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramChatsUserControllerGetTokenQueryResponse,
        ResponseErrorConfig<TelegramChatsUserControllerGetToken401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramChatsUserGetTokenQueryKey();

  const query = useQuery(
    {
      ...telegramChatsUserGetTokenQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramChatsUserControllerGetToken401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
